<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" *ngIf="!oneLine">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
    <a href="https://www.mozilla.org/fr/firefox/new/" rel="noopener" target="_blank">
      <img class="img-fluid" src="../../../assets/img/firefox.png" alt="Mozilla Firefox"
           style="height: 55px; max-width: 100%;">
    </a>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <a href="https://www.google.fr/chrome/index.html" rel="noopener" target="_blank">
      <img class="img-fluid" src="../../../assets/img/chrome.png" alt="Google Chrome"
           style="height: 55px; max-width: 100%;">
    </a>
  </div>
</div>

<div class="row" *ngIf="oneLine">
  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <a href="https://www.mozilla.org/fr/firefox/new/" rel="noopener" target="_blank">
      <img class="img-fluid" src="../../../assets/img/firefox.png" alt="Mozilla Firefox"
           style="height: 55px; max-width: 100%;">
    </a>
  </div>

  <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <a href="https://www.google.fr/chrome/index.html" rel="noopener" target="_blank">
      <img class="img-fluid" src="../../../assets/img/chrome.png" alt="Google Chrome"
           style="height: 55px; max-width: 100%;">
    </a>
  </div>
</div>




